import { getDefaultStore } from "jotai";

import { focusedFindingIndexAtom, orderedFindingsAtom } from "../../atoms/findingsAtoms";
import { registerCommand, runCommand } from "./registry";

registerCommand("advanceFocusedFinding", ({ direction }) => {
  const store = getDefaultStore();
  const findings = store.get(orderedFindingsAtom);
  const current = store.get(focusedFindingIndexAtom);

  if (findings.length === 0 || current === null) return;

  const step = direction === "next" ? 1 : -1;
  const next = (current + step + findings.length) % findings.length;
  const finding = findings[next];

  store.set(focusedFindingIndexAtom, next);
  runCommand("selectFinding", {
    finding: finding.condition,
    target:
      finding.seriesId != null && finding.sliceIndex != null
        ? {
            seriesId: finding.seriesId,
            sliceIndex: finding.sliceIndex,
            frameOfReferenceUid: finding.frameOfReferenceUid ?? null,
          }
        : null,
  });
});
